import React from 'react';
import Box from '@mui/material/Box';
import Icon from '@mui/material/Icon';
import Typography from '@mui/material/Typography';
import BlockRoundedIcon from '@mui/icons-material/BlockRounded';
import { node, string } from 'prop-types';

const NoResultsBanner = ({
  bannerBackgroundColor,
  icon,
  iconColor,
  iconFill,
  iconHeight,
  iconWidth,
  primaryText,
  primaryTextAlign,
  primaryTextVariant,
  primaryTypographyColor,
  secondaryText,
  secondaryTextAlign,
  secondaryTypographyColor,
  secondaryTextVariant,
}) => {
  return (
    <Box
      alignItems="center"
      bgcolor={bannerBackgroundColor}
      borderRadius="4px"
      color="text.secondary"
      display="flex"
      flexDirection="column"
      fontFamily="Overpass"
      fontWeight={300}
      height="calc(100% - 16px)"
      justifyContent="center"
      margin={0}
      padding={3}
      sx={{
        boxShadow: theme => theme.shadows[11],
      }}
      textAlign="center"
      width="calc(100% - 16px)"
    >
      <Icon
        sx={{ color: iconColor, fill: iconFill, height: iconHeight, mb: 1.5, width: iconWidth }}
      >
        {icon}
      </Icon>
      <Typography
        sx={{ color: primaryTypographyColor, mb: 1, textAlign: primaryTextAlign }}
        variant={primaryTextVariant}
      >
        {primaryText}
      </Typography>
      <Typography
        sx={{ color: secondaryTypographyColor, mb: 1.5, textAlign: secondaryTextAlign }}
        variant={secondaryTextVariant}
      >
        {secondaryText}
      </Typography>
    </Box>
  );
};

NoResultsBanner.propTypes = {
  bannerBackgroundColor: string,
  icon: node,
  iconColor: string,
  iconFill: string,
  iconHeight: string,
  iconWidth: string,
  primaryText: string,
  primaryTextAlign: string,
  primaryTextVariant: string,
  primaryTypographyColor: string,
  secondaryText: string,
  secondaryTextAlign: string,
  secondaryTextVariant: string,
  secondaryTypographyColor: string,
};

NoResultsBanner.defaultProps = {
  bannerBackgroundColor: '_next.common.black._states.hover',
  icon: <BlockRoundedIcon fontSize="inherit" />,
  iconColor: '_next.text.primary',
  iconFill: '_next.text.primary',
  iconHeight: 24,
  iconWidth: 24,
  primaryText: 'No results found',
  primaryTextAlign: 'center',
  primaryTextVariant: 'h6',
  primaryTypographyColor: '_next.text.primary',
  secondaryText: 'Try adjusting your search or filter options.',
  secondaryTextAlign: 'center',
  secondaryTextVariant: 'body1',
  secondaryTypographyColor: '_next.text.primary',
};

export default NoResultsBanner;
